import { Middleware, MiddlewareApi } from '../index';
import { AuthType, tokenExpired, TokenProvidedAction } from './action';
import { redirectRequested } from '../Redirect/action';
import { getLabels, getPeriodsInfo } from '../../Service/Interest/InterestService';
import { labelsLoaded } from '../Label/action';
import { periodsLoaded } from '../Period/action';
import { finishedLoading } from '../App/action';
import { errorHasBeenThrown } from '../Error/action';
import { ErrorResponse } from '../../Interface/ErrorResponse';
import { filterResetRequested } from '../Filter/action';
import useGetEngine from '../../Hook/UseGetEngine';

export class AuthMiddleware {
    public middleware: Middleware = store => next => action => {
        next(action);

        const { isViisi } = useGetEngine();

        switch (action.type) {
            case AuthType.TokenProvided:
                return this.appInitializedAction(store, action);
            case AuthType.TokenExpired:
                if (isViisi()) {
                    return store.dispatch(redirectRequested('/'));
                }
                return store.dispatch(redirectRequested('/geen-toegang'));
        }
    };

    private appInitializedAction(store: MiddlewareApi, action: TokenProvidedAction): void {
        Promise.all([getLabels(), getPeriodsInfo()]).then(
            ([labels, periods]) => {
                setTimeout(() => {
                    store.dispatch(filterResetRequested());
                    store.dispatch(labelsLoaded(labels));
                    store.dispatch(periodsLoaded(periods));
                    store.dispatch(finishedLoading(action.url));
                }, 3000);
            },
            (errorResult: ErrorResponse) =>
                errorResult.code === 403
                    ? store.dispatch(tokenExpired())
                    : store.dispatch(errorHasBeenThrown(new Error(errorResult.message))),
        );
    }
}
